import moment from 'moment';
import React, { useEffect } from 'react';
import { Controller, useForm } from 'react-hook-form';
import styled from 'styled-components';
import Button from '../../atoms/Buttons';
import DateTimeRange from '../../atoms/DateTimeRange';
import Label from '../../atoms/Label';

type Query = {
  from: moment.Moment | null | undefined;
  to: moment.Moment | null | undefined;
};

type Props = {
  query: Query;
  setQuery: (query: Query) => void;
};

type FormFilterParams = {
  date_range: {
    from: moment.Moment | null;
    to: moment.Moment | null;
  };
};

const FilterFormWrapper = styled.div`
  display: flex;
  gap: 6px;
  align-items: center;
  margin-top: 16px;

  ${Label}, ${DateTimeRange} {
    margin: 0;
  }
`;

const FilterForm = ({ query, setQuery }: Props) => {
  const formValues = {
    date_range: {
      from: query.from ?? null,
      to: query.to ?? null,
    },
  };

  const { handleSubmit, control, reset } = useForm<FormFilterParams>({
    defaultValues: formValues,
  });

  const onSubmit = (data: FormFilterParams) => {
    const { date_range } = data;

    setQuery({ ...date_range });
  };

  useEffect(() => {
    reset(formValues);
  }, [query]);

  return (
    <FilterFormWrapper>
      <Label>抽出期間</Label>
      <Controller
        name="date_range"
        control={control}
        render={({ field: { value, onChange } }) => (
          <DateTimeRange
            dateRange={{
              from: value.from,
              to: value.to,
            }}
            setDateRange={(range) => {
              if (!range?.from?.isSame(value?.from)) {
                onChange({
                  from: range.from ?? null,
                  to: range.from?.clone().add(3, 'months').subtract(1, 'day').endOf('day') ?? null,
                });
                return;
              }

              onChange({ from: range.from ?? null, to: range.to ?? null });
            }}
            dateTimeProps={{
              fromProps: { showIcon: true },
              toProps: {
                showIcon: true,
                isValidDate: (current) => {
                  if (value.from?.isAfter(current)) {
                    return false;
                  }

                  if (value.from?.clone().add(3, 'months').subtract(1, 'day').isBefore(current)) {
                    return false;
                  }

                  return true;
                },
              },
            }}
          />
        )}
      />
      <Button onClick={handleSubmit(onSubmit)}>検索</Button>
    </FilterFormWrapper>
  );
};

export default FilterForm;
